export default __webpack_public_path__ + "static/media/setting.ac286474.svg";